import React from 'react';
import { default as BootstrapSpinner } from 'react-bootstrap/Spinner'

export default function Spinner(props) {
    return (
        <div style={{ height: props.height || '20vh', padding: '10vh' }}>
            <BootstrapSpinner variant="primary" animation="border" />
        </div>
    )
}